import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks/reduxHooks';
import { CLAVES_NOMBRE_PASO } from '../pasos';

interface CarcinogenicModuleFooterProps {
    handleCancelClick: any;
    handleSubmitClick: any;
    lastPage?: boolean;
    disableCancelButton?: boolean;
    disableNextButton?: boolean;
    onlyVisual?: boolean;
}

const CarcinogenicModuleFooter = ({
    handleCancelClick,
    handleSubmitClick,
    lastPage = false,
    disableCancelButton = false,
    disableNextButton = false,
    onlyVisual = false
}: CarcinogenicModuleFooterProps) => {
    const { t } = useTranslation('carcinogenicReport');
    // El paso actual sale del store, no de una prop: así los seis módulos que
    // usan el pie no tienen que saber cuál es el siguiente.
    const pasoActual = useAppSelector((state) => state?.carcinogenicReport?.currentTab);
    const claveSiguiente =
        typeof pasoActual === 'number' ? CLAVES_NOMBRE_PASO[pasoActual + 1] : undefined;

    const textoSiguiente =
        lastPage && !onlyVisual
            ? t('footer.buttons.sendReport')
            : claveSiguiente
            ? t('footer.buttons.nextTo', { paso: t(claveSiguiente) })
            : t('footer.buttons.next');

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                mt: 2,
                position: 'sticky',
                bottom: 0,
                zIndex: 2,
                backgroundColor: '#FFFFFF',
                paddingY: 1.5
            }}
        >
            <Button
                variant="outlined"
                onClick={handleCancelClick}
                sx={{ mr: 1 }}
                disabled={disableCancelButton}
                data-testid={!onlyVisual ? 'footer.buttons.cancel' : 'footer.buttons.previous'}
            >
                {!onlyVisual ? t('footer.buttons.cancel') : t('footer.buttons.previous')}
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitClick}
                disabled={disableNextButton}
                data-testid={'footer.buttons.next'}
            >
                {textoSiguiente}
            </Button>
        </Box>
    );
};

export { CarcinogenicModuleFooter };
